import { render, staticRenderFns } from "./AlertsDetails.vue?vue&type=template&id=2e7c5495&scoped=true&"
import script from "./AlertsDetails.vue?vue&type=script&lang=ts&"
export * from "./AlertsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AlertsDetails.vue?vue&type=style&index=0&id=2e7c5495&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c5495",
  null
  
)

export default component.exports